var flexJustifyBetween = {
  "justifyContent": "space-between !important"
};

export { flexJustifyBetween };
